"use strict";

var _createForOfIteratorHelper = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/suspense.ts


var suspense_exports = {};

__export(suspense_exports, {
  defaultThrowOnError: function defaultThrowOnError() {
    return _defaultThrowOnError;
  },
  ensureSuspenseTimers: function ensureSuspenseTimers() {
    return _ensureSuspenseTimers;
  },
  fetchOptimistic: function fetchOptimistic() {
    return _fetchOptimistic;
  },
  shouldSuspend: function shouldSuspend() {
    return _shouldSuspend;
  },
  willFetch: function willFetch() {
    return _willFetch;
  }
});

module.exports = __toCommonJS(suspense_exports);

var _defaultThrowOnError = function _defaultThrowOnError(_error, query) {
  return query.state.data === void 0;
};

var _ensureSuspenseTimers = function _ensureSuspenseTimers(defaultedOptions) {
  if (defaultedOptions.suspense) {
    var clamp = function clamp(value) {
      return value === "static" ? value : Math.max(value !== null && value !== void 0 ? value : 1e3, 1e3);
    };

    var originalStaleTime = defaultedOptions.staleTime;
    defaultedOptions.staleTime = typeof originalStaleTime === "function" ? function () {
      return clamp(originalStaleTime.apply(void 0, arguments));
    } : clamp(originalStaleTime);

    if (typeof defaultedOptions.gcTime === "number") {
      defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
  }
};

var _willFetch = function _willFetch(result, isRestoring) {
  return result.isLoading && result.isFetching && !isRestoring;
};

var _shouldSuspend = function _shouldSuspend(defaultedOptions, result) {
  return (defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
};

var _fetchOptimistic = function _fetchOptimistic(defaultedOptions, observer, errorResetBoundary) {
  return observer.fetchOptimistic(defaultedOptions).catch(function () {
    errorResetBoundary.clearReset();
  });
}; // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = {
  defaultThrowOnError: _defaultThrowOnError,
  ensureSuspenseTimers: _ensureSuspenseTimers,
  fetchOptimistic: _fetchOptimistic,
  shouldSuspend: _shouldSuspend,
  willFetch: _willFetch
});